import { z } from "zod/v4"
import { UserId } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { FirestoreTimestampSchema } from "./system"

export const UserSystemNotificationCheckStatusDocumentMeta = z.object({
  last_checked_at: FirestoreTimestampSchema.nullable().describe("最後に運営からのお知らせをチェックした日時"),
})

export type UserSystemNotificationCheckStatusDocumentMeta = z.infer<typeof UserSystemNotificationCheckStatusDocumentMeta>

export const UserSystemNotificationCheckStatusDocumentBody = UserSystemNotificationCheckStatusDocumentMeta

export type UserSystemNotificationCheckStatusDocumentBody = z.infer<typeof UserSystemNotificationCheckStatusDocumentBody>

export type UserSystemNotificationCheckStatusDocument = UserSystemNotificationCheckStatusDocumentBody & {
  id: UserId,
}

export class UserSystemNotificationCheckStatusDocuments {

  static toDocumentData(doc: UserSystemNotificationCheckStatusDocumentBody): object {
    return {
      ...doc,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): UserSystemNotificationCheckStatusDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: UserId(doc.id),
      last_checked_at: data["last_checked_at"],
    }
  }
}